// https://api-alpha.ethizo.com/procedures.json
import axios from "axios";
import { baseApi } from "../redux/baseAPI";

export const procedureApi = baseApi.injectEndpoints({
  tagTypes: ["Procedure", "Refusal", "Inventory"],
  endpoints: (builder) => ({
    getProcedure: builder.query({
      query: (patientId) => {
        return {
          url: `/procedures.json`,
          method: "GET",
          params: {
            page: 1,
            limit: 9999,
            pid: patientId,
            current_loc: "patient/procedures/procedures",
          },
        };
      },
      providesTags: ["Procedure"],
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    deleteProcedure: builder.mutation({
      query: (body) => {
        return {
          url: `/procedures/delete.json`,
          method: "GET",
          params: {
            current_loc: "patient/encounter/provider_note/procedures",
            audit_encounter_id: body.encounter,
            encounter: body.encounter,
            id: body.id,
          },
        };
      },
      invalidatesTags: ["Procedure"],
      transformResponse: (response, meta, arg) => response,
    }),
    //here is the api for signed the procedure
    signProcedure: builder.mutation({
      query: (payload) => ({
        url: `/procedures/sign.json`,
        method: "GET",
        params: {
          id: payload?.id,
          sign: payload?.sign,
        },
      }),
      invalidatesTags: ["Procedure"],
    }),
    getReducers: builder.query({
      query: (patientId) => {
        return {
          url: `/procedures/settings.json`,
          method: "GET",
          params: {
            pid: patientId,
          },
        };
      },
    }),
    // /procedures/add.json
    addProcedure: builder.mutation({
      query: (payload) => {
        return {
          url: `/procedures/add.json`,
          method: "POST",
          data: payload,
        };
      },
      invalidatesTags: ["Procedure"],
    }),
    getTbProcedure: builder.mutation({
      query: (payload) => ({
        url: `/form_builder/get_by_slug.json`,
        method: "GET",
        params: {
          current_loc: "patient/procedures/add_procedure",
          slug: payload.slug,
          tbt: 0,
        },
      }),
      invalidatesTags: ["Procedure"],
    }),
    getPatientForm: builder.mutation({
      query: (payload) => ({
        url: `/patient_forms/get_form.json`,
        method: "GET",
        params: {
          id: payload.id,
          tbt: 0,
          current_loc: `patient/procedures/add_procedure`,
        },
      }),
      invalidatesTags: ["Procedure"],
    }),
    getLetterTemplate: builder.mutation({
      query: (payload) => ({
        url: `/ClinicalTemplate/preview_template.json`,
        method: "GET",
        params: {
          tbt: 0,
          current_loc: `patient/procedures/procedures`,
          id: payload?.id,
          pid: payload.pid,
          preview: "letter",
          procedure_id: payload.procedure_id,
        },
      }),
      invalidatesTags: ["Procedure"],
    }),
    postSignLetter: builder.mutation({
      query: (payload) => ({
        url: `/ClinicalTemplate/sign_letter.json`,
        method: "POST",
        data: payload,
        params: {
          tbt: 0,
          current_loc: `patient/procedures/procedures`,
        },
      }),
      // invalidatesTags: ["Procedure"],
    }),
    procedureRefusalReasons: builder.query({
      query: () => ({
        url: `/refusals/settings.json`,
        method: "GET",
        params: {
          type: "procedures",
        },
      }),
      // invalidatesTags: ["Procedure"],
    }),
    addReviewProcedures: builder.mutation({
      query: (payload) => ({
        url: `/procedures/addReview.json`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["Procedure"],
    }),
    printProcedures: builder.mutation({
      query: (payload) => {
        return {
          url: `/procedures/requisition_report.json`,
          method: "POST",
          params: payload,
        };
      },
      // invalidatesTags: ["Procedure"],
    }),
    shareEfax: builder.mutation({
      query: (payload) => {
        return {
          url: `/efax/efax_request.json`,
          method: "POST",
          data: payload,
        };
      },
      // invalidatesTags: ["Procedure"],
    }),
    shareReport: builder.mutation({
      query: (payload) => {
        return {
          url: `/share_data/share_report_by_email.json`,
          method: "POST",
          data: payload,
        };
      },
      // invalidatesTags: ["Procedure"],
    }),
    deleteRefusalProcedure: builder.mutation({
      query: (body) => ({
        url: `/refusals/delete.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Procedure"],
    }),
    getEfaxInfo: builder.query({
      query: () => ({
        url: `/efax/get_all_efax.json`,
        method: "GET",
        params: {
          type: "procedures",
        },
      }),
      // invalidatesTags: ["Procedure"],
    }),
    getProcedureRefusal: builder.query({
      query: (patientId) => {
        return {
          url: `/refusals.json`,
          method: "GET",
          params: {
            page: 1,
            limit: 20,
            pid: patientId,
            type: "procedures",
          },
        };
      },
      providesTags: ["Refusal"],
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    // getInventoryInfo: builder.query({
    //   query: (data) => {
    //     return {
    //       url: `/inventory/index.json`,
    //       method: "GET",
    //       params: {
    //         //limit: 999999,
    //         //pid: patientId,
    //         page: 1,
    //         active: true,
    //         is_expired: "all",
    //         is_available: true,
    //         inventory_type_id: "33756"
    //       },
    //     };
    //   },
    //   providesTags: ["Inventory"],
    //   transformResponse: (response, meta, arg) => response.response.data,
    // }),
    generateQrcode: builder.query({
      query: (param) => {
        return {
          url: `/patients/generate_qr_code.json`,
          method: "GET",
          params: { ...param },
        };
      },
    }),
  }),
});
// https://api-alpha.ethizo.com/procedures/settings.json
export const {
  useGetProcedureQuery,
  useDeleteProcedureMutation,
  useSignProcedureMutation,
  useGetReducersQuery,
  useAddProcedureMutation,
  useGetTbProcedureMutation,
  useGetPatientFormMutation,
  useGetLetterTemplateMutation,
  usePostSignLetterMutation,
  useProcedureRefusalReasonsQuery,
  useAddReviewProceduresMutation,
  usePrintProceduresMutation,
  useGetProcedureRefusalQuery,
  useGetEfaxInfoQuery,
  useShareEfaxMutation,
  useShareReportMutation,
  useDeleteRefusalProcedureMutation,
  useGetInventoryInfoQuery,
  useGenerateQrcodeQuery,
} = procedureApi;

export function printSingleConcent(payload) {
  return axios.post(
    `${process.env.REACT_APP_API_URL_V1}/utilities/save_temp_data_for_print.json`,
    payload
  );
}

export function inventoryData() {
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/inventory/index.json?page=1&limit=99999&active=true&is_expired=all&inventory_type_id=33756`
  );
}
